export default function SVGBear({ opacity }) {
  return (
    <g style={{ willChange: 'opacity' }} opacity={opacity}>
      <g id="Bear-2-2" data-name="Bear-2">
        <path
          d="M372.66,7639.53s-19.47,71.9-30.59,96.66S311,7807.56,308.18,7817s-7.82,21.85-2.65,30.06c-10.07,8.87-105.66,66.73-105.66,66.73s-23.44,25.69-3.31,56.94,41.44,22.11,62.36,10.59a283.2,283.2,0,0,0,33.9-21.45l123.53-96.92h0l-79.18,67.39s-37.6,37.47-3,81.17c31.38,21.05,76.26-1.86,78.38-20.79s66.74-100.37,66.74-100.37l8.47-60.9,7.81,38.13s23.44,39.59,58.92,16.82,6.62-70.71,2.65-77.73S454.75,7637.68,455,7620.73s-51.25,6.49-51.25,6.49l-20.52,1.46-10.59,10.85"
          fill="#f7f7f7"
        />
        <path
          d="M311.88,7845.83s5.43-36,20.13-65.28,32.7-92,35.35-103.28,6.75-36,18-38.66,38.27-8.21,50.71-16,14,4,41.31,58,111.62,167.1,77.2,204.17c-31.91,46.48,48.85-33.5,48.85-33.5l-17.34-104.6-89.38-144.59-116.38-6L312,7680.71,292.82,7800v52.7l19.06-6.88"
          fill="#fff"
        />
        <path
          d="M318.11,7523.81s-44.36-2.91-22.25-53.76c26.09-30.85,64.35-23.83,71.9,6.89l24.23-4.5s25.42-.93,34.43,6.48c15.09-14,11.91-16.68,26.48-17.87s37.2,2.51,44.49,10.19,20.39,24.76,12.84,42.24-32.44,22.78-32.44,22.78-4.5,39.72-16.15,51.9c-15.76,20.79-103.28,74.15-141.15-19.2-10.46-40.52-2.38-45.15-2.38-45.15"
          fill="#f7f7f7"
        />
        <path
          d="M386,7617.55c-24.89-7.41-61.44-26.48-60-67.79.27-8.87.8-16.55,1.46-23.17a9.59,9.59,0,0,0-8.61-10.72,10.55,10.55,0,0,0-4.1.39c-18.54,2.65-28.07-30.45-3.45-50.45s40-5,47.94-5c9.13-6.09-8-42.9-8-42.9l-72.69,18,2.65,100.5h23.3l27.28,92.82H374l23.84-6.76-9.41-4.23"
          fill="#fff"
        />
        <circle cx="412.25" cy="7547.51" r="3.84" fill="#fff" />
        <circle cx="332.01" cy="7547.51" r="3.84" fill="#fff" />
        <path
          d="M196.56,7970.55s-16.55-44.49,3.31-56.93,47.13-17.74,58.79,0,18.8,31.64,14,47.93-40,39.06-54.15,30.45a70.73,70.73,0,0,1-22-21.45"
          fill="#ececec"
        />
        <path
          d="M318.9,7953.08s19.73-39.46,56.8-29.4c35.75,12.31,40.79,61.57,40.79,61.57s-15.23,33-49.13,33.76c-29.92.67-51.37-17.74-51.11-41.31l2.65-24.62"
          fill="#ececec"
        />
        <path
          d="M218.54,7992s-38.14-15.22-27.81-61.7c16-47.27,63.16-21.05,63.16-21.05s-36.15-6.49-51.64,15.23c-10.86,13.77-9.8,49.78,16.29,67.52"
          fill="#fff"
        />
        <path
          d="M347.5,8019s-39.19-10.46-27.8-66.2c13.77-40.65,59.71-32.31,60.64-25.55-5.43-1.46-32-7.42-49,19.33-11,14.69-13.64,53,12.58,67.66"
          fill="#fff"
        />
        <path
          d="M249.52,7905.81s-10.2-5.83-3.05-11.52,64-40,64-40,20.78,3.84,37.73-14.3c-6.62-3.18-8.47-3.31-8.47-3.31s-21.19,18.67-34.16,10.33c-31.38,20.92-84.08,53.62-84.08,53.62l28.07,5.17"
          fill="#fff"
        />
        <path
          d="M369.48,7922.09s-10.86-4.37-4.63-11,58.39-42.76,58.39-42.76,20.79-11.79,35.22-31.92h0s-26.88,28.47-41,25.29c-28.47,24.77-76.53,64-76.53,64l23-3.58"
          fill="#fff"
        />
        <path
          d="M384.71,7655l-27.28,115.72-15.62,65.14,6.49,3.84s9.79-4.36,6.75-15.09S374,7732.88,376.9,7721.1c11.12-45.29,8.47-65.94,8.47-65.94"
          fill="#fff"
        />
        <path
          d="M408.54,7959.83s58.66-64.48,60.91-93.22c15.09-80-28.07-206.68-14.3-215,15.89-7.28,34.16,132.81,34.16,132.81s13,92.68,44.22,106.32c-24.23-2.65-41-3.31-47.13-68.32,2.91-36.68-19.6-137.84-19.6-137.84S461,7657,456.21,7653.44c-2.65,11.12,12.84,81.43,12.84,81.43s13.37,57.59,15.36,77.19c1.46,14,.27,56.27.27,56.27l-5.3,22.12L412,7992l1.86-19.2"
          fill="#ececec"
        />
        <path
          d="M363.52,7594.78l11.79,13.37c40.38,24.63,62.23-.26,82.22-17.61s20.39-54.28,20.39-54.28L458.59,7529s-8.87-14.43-10.46-22.77c-11.39,23.3,20,34,20,34s1.86,34.16-34,58S363.65,7595.18,363.52,7594.78Z"
          fill="#ececec"
        />
        <path
          d="M258.92,7981.15s20.66-13.91,11.92-48.33c25.82-5.7,67.52-26.88,89.5-51.77,5.83.13,2.65,4.1,2.65,4.1s-54.68,67-78.25,80.24c-19.6,12.31-25.82,15.76-25.82,15.76"
          fill="#ececec"
        />
        <path
          d="M448,7506.46s3.44,38.14,40.78,27.81c36.15-19.33,19.46-49.65,19.46-49.65s3.45,21.45-10.85,30.05c-25.16,21.32-49.39-8.34-49.39-8.21"
          fill="#ececec"
        />
        <path
          d="M427.74,7479.72s.93-1.33,3.71,4.1c10.59-10.19,34.42-27.27,65.94-12.44l-9.8-6.23S457,7453.9,433,7467.67a35.85,35.85,0,0,0-10.33,8.08"
          fill="#fff"
        />
        <path
          d="M386.3,7810.21a77.52,77.52,0,0,1,7.68-36.94"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="6"
        />
        <path
          d="M388.15,7826.23c-.26-1.06-.4-2.25-.66-3.58"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="6"
        />
      </g>
      <g id="Layer_9" data-name="Layer 9">
        <path
          d="M285.8,7987.63c13.64-84.34,85.14-119.3,77.19-102.22s-135,162.2-166.43,85.14c-25.29-62.23,25.68-72.82,45-67.26,23.84,4.77,50.05,53.1,17.35,78-61.57,46.74-90.3-52.17-51.11-73.22,25-13.51,77.06-45.42,110.43-66.21a35.56,35.56,0,0,1,48.86,11.26,35.94,35.94,0,0,1,3.44,7.15c1.19,3.57,1.59,6.49.53,8.07-4,5.83-15.1-13-22.91-28.33a36.89,36.89,0,0,1-3.17-23.17c20.78-120.89,33.23-162.86,37.6-162.47.53,0,1.32.53,1.19,1.06-25.16,113.21-39.19,168.43-41.18,177.3-9.13,14.83-29.53,20.39-36.94,14.3-13.11-10.86,33.76-101.43,43-126.45,8.74-23.44,16.69-59.32,24-81a17.36,17.36,0,0,1,17.74-11.78c22.78,1.46,39.59-9.67,51.24-13.24a11.34,11.34,0,0,1,13.38,6.35c56.27,131.62,119.16,189.88,116.51,231.05-1.45,21.32-12,32.44-25.68,36.81-22,7.29-48.07-4.9-52.17-27.8-16.15-90.7-42.24-203.91-37.34-207.35,5.69-.4,32.44,114.93,30.19,185.37-.66,22.9-.8,45.28-13.77,64.22L412,7992s-5.29,24.1-44.62,27c-59.71,4.64-69.51-76.93-18.54-96.26s105.27,92.42,18.54,96.26c-48.86,2.12-53.49-36.81-49.92-57.73a65.06,65.06,0,0,1,24.23-40.38c32.44-25.69,116.52-91.76,116.92-84.35.27,4.37-10.72,12.32-23.44,19.34-27.54,15.49-60.37-.4-65.54-31.52-3.84-23,2.52-43.16,2.78-49.38.53-10.46-11.91,2.51-2.78,3,8.34.53,5.56-15.09,13.77-38.4,14.17-39.85,33.24-91.09,20.39-112.28-9-14.3-42.5-.13-72.42-38.4-23.31-31.11-15.89-69.25-9.67-79.57s10.33,3.31-3.44,14.56c-10.06,8.34-45.68-18.93-22.25-53.89,21.06-29.26,53.63-24.36,67.53-9,9.54,10.59,2.12,30.45-3.71,25-10.06-9.27,57.34-23.43,20.4-1.19-38.93,23.57-33.77,75.47-26.88,90.3,1.06,6,13.11,4.9,12.18-3.7-.66-6.09-3.18-7.82-6.09-7.68-9.4.66-6.23,11.25-6.23,11.25,25.56,68.19,97.32,43.7,116.66-.53s-1.2-68.85-6.23-72.69c-7.15-5.43-17.74-1.46-14,13a29.08,29.08,0,0,0,35.61,20.78h.14a18.47,18.47,0,0,0,3.57-1.19c13.24-5.43,24.5-18,23.7-34.16-1.72-30.72-38.66-50.05-71-35.22s-17.08,30.06-11.91,27.28c1.32-.66,4-6.89-3.18-13.24a94.12,94.12,0,0,1-20-25.56"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </g>
  );
}

export function MobileSVGBear({ opacity }) {
  return (
    <g style={{ willChange: 'opacity' }} opacity={opacity}>
      <g id="Bear-2-2-2-2" data-name="Bear-2-2-2">
        <path
          d="M380.52,4860.6s-8.45,31.21-13.28,42-13.49,31-14.71,35.08-3.4,9.49-1.15,13c-4.37,3.85-45.87,29-45.87,29s-10.18,11.15-1.44,24.72,18,9.6,27.07,4.59a122.46,122.46,0,0,0,14.72-9.31l53.62-42.07h0l-34.37,29.25s-16.32,16.27-1.3,35.24c13.62,9.14,33.1-.81,34-9s29-43.57,29-43.57l3.67-26.43,3.39,16.55s10.18,17.19,25.58,7.3,2.87-30.69,1.15-33.74-44.45-73.36-44.34-80.72-22.25,2.82-22.25,2.82l-8.9.63-4.6,4.71"
          fill="#f7f7f7"
        />
        <path
          d="M354.13,4950.16s2.36-15.63,8.74-28.34,14.2-39.94,15.35-44.83,2.93-15.63,7.81-16.79,16.61-3.56,22-6.94,6.08,1.73,17.94,25.18,48.45,72.53,33.51,88.63c-13.85,20.17,21.21-14.55,21.21-14.55l-7.53-45.4-38.8-62.77-50.52-2.6-29.66,36.73-8.33,51.78v22.88l8.27-3"
          fill="#fff"
        />
        <path
          d="M356.84,4810.37s-19.26-1.26-9.66-23.34c11.33-13.39,27.93-10.34,31.21,3l10.52-2s8.78-.32,13.47,1.9a2.53,2.53,0,0,0,2.9-.45c5-4.9,4.25-5.92,10.07-6.4,6.32-.52,18,1.16,21.18,4.49s8,9.44,3.7,18.27c-3.61,7.44-14.08,9.89-14.08,9.89s-2,17.25-7,22.53c-6.84,9-44.83,32.19-61.27-8.33-4.54-17.59-1-19.6-1-19.6"
          fill="#f7f7f7"
        />
        <path
          d="M386.31,4851.06c-12.6-2.93-32.17-22-25.85-38.45a4,4,0,0,0-3.19-5.68h-.11a4.66,4.66,0,0,0-1.78.17c-8.05,1.15-12.19-13.22-1.5-21.9s17.37-2.17,20.81-2.17c4-2.64-3.47-18.62-3.47-18.62l-31.55,7.81,1.15,43.63h10.11l11.84,40.29H381.1l10.35-2.93-4.09-1.84"
          fill="#fff"
        />
        <circle cx="397.7" cy="4820.66" r="1.67" fill="#fff" />
        <circle cx="362.87" cy="4820.66" r="1.67" fill="#fff" />
        <path
          d="M304.07,5004.3s-7.18-19.31,1.44-24.71,20.46-7.71,25.52,0,8.16,13.73,6.08,20.8-11.4,17.94-25.34,13.22c-3.83-2.36-5.26-5.54-7.72-9.31"
          fill="#ececec"
        />
        <path
          d="M357.18,4996.72s8.57-17.13,24.66-12.77c15.52,5.35,17.71,26.73,17.71,26.73s-4.7,16.31-21.33,14.66c-13,.29-22.3-7.71-22.19-17.94l1.15-10.68"
          fill="#ececec"
        />
        <path
          d="M313.61,5013.61c-2.17,2-16.55-6.61-12.07-26.78,6.95-20.52,27.42-9.14,27.42-9.14s-15.69-2.82-22.42,6.61c-4.71,6-4.44,24.6,7.07,29.31"
          fill="#fff"
        />
        <path
          d="M369.6,5025.33s-17-4.54-12.07-28.74c6-17.64,25.92-14,26.32-11.09-2.35-.63-13.89-3.22-21.27,8.39-4.77,6.38-5.92,23,5.46,29.38"
          fill="#fff"
        />
        <path
          d="M327.06,4976.2s-4.42-2.54-1.32-5,27.78-17.36,27.78-17.36a19,19,0,0,0,16.38-6.21,13.52,13.52,0,0,0-3.68-1.43s-9.19,8.1-14.83,4.48c-13.62,9.08-36.49,23.28-36.49,23.28l12.18,2.24"
          fill="#fff"
        />
        <path
          d="M379.14,4983.26s-4.72-1.89-2-4.77,25.35-18.56,25.35-18.56a54.08,54.08,0,0,0,15.28-13.86h0s-11.66,12.36-17.79,11c-12.36,10.75-33.23,27.78-33.23,27.78l10-1.55"
          fill="#fff"
        />
        <path
          d="M385.75,4867.32l-11.84,50.23-6.78,28.28v1.67c2-.94,3.57.53,4.9-3.26a13.66,13.66,0,0,0,.72-4.54c0-7.77,8.43-38.9,9.61-43.69,4.83-19.66,3.68-28.62,3.68-28.62"
          fill="#fff"
        />
        <path
          d="M396.09,4999.65s25.47-28,26.45-40.47c6.55-34.73-12.19-89.72-6.21-93.33,6-2.73,14.19,46.3,16.3,59.59.3,1.84.53,3.69.73,5.54.9,8.57,4.9,38.55,17,38.67-10.52-1.15-17.19-2.21-19.85-30.43,1.27-15.93-9.12-59.06-9.12-59.06s-2.51-12-4.59-13.52c-1.15,4.83,5.57,35.35,5.57,35.35s6.76,24.76,7.62,33.27c.63,6.08,2.84,15.67,1.28,24.28-.52,2.84-3.9,10.9-3.9,10.9l-29.76,43.17.8-8.33"
          fill="#ececec"
        />
        <path
          d="M376.55,4841.18l5.12,5.8c17.53,10.69,27.24.56,35.93-7s8.61-24.24,8.61-24.24l-8.39-3.15a94.87,94.87,0,0,1-3.31-10.68c-.9,9.19,7.45,15.56,7.45,15.56s.81,14.83-14.76,25.17S376.61,4841.35,376.55,4841.18Z"
          fill="#ececec"
        />
        <path
          d="M331.14,5008.9s9-6,5.18-21c11.21-2.47,29.31-11.67,38.85-22.47,2.53,0,1.15,1.78,1.15,1.78s-23.74,29.08-34,34.83c-8.51,5.34-11.21,6.84-11.21,6.84"
          fill="#ececec"
        />
        <path
          d="M414.23,4803.19s1.9,15.8,15.34,14.68a6,6,0,0,0,2.45-1c16.48-12.72,8.05-24.69,8.05-24.69s-.16,9.41-5.41,14.91c-10.92,9.26-19.41-3.81-20.43-3.93"
          fill="#ececec"
        />
        <path
          d="M402.88,4789.47a4.82,4.82,0,0,1,3.47,3.24c4.6-4.42,14.63-12.54,28.31-6.1l-4.05-2.52s-13.37-4.78-23.9,1.91a15.29,15.29,0,0,0-4.48,3.51"
          fill="#fff"
        />
        <path
          d="M386.44,4934.7a33.64,33.64,0,0,1,3.33-16"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M387.24,4941.65c-.11-.46-.17-1-.28-1.55"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
      <g id="Layer_9" data-name="Layer 9">
        <path
          d="M428.79,4817.86l.28,0a12.41,12.41,0,0,0,5.33-2.37c4.49-3.47,8-10.93,7.87-16.64-.74-13.34-17.76-20.42-31.8-14s-6.67,13-4.43,11.82c.57-.29,1.69-3.76-1.43-6.51-3.52-3.17-3.88-7.17-6.1-11.34"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M342.81,5011.71c5.92-36.61,37-51.78,33.51-44.37s-58.95,70.88-72.6,37.47c-11-27,11.5-32.08,19.89-29.67,10.35,2.07,21.72,24,7.53,34.86-26.73,20.29-39.2-23.65-22.19-32.78,10.86-5.87,33.45-19.72,47.94-28.75a15.39,15.39,0,0,1,22.7,8c.52,1.55.69,2.81.23,3.5-1.73,2.53-6.55-5.64-9.94-12.3a16,16,0,0,1-1.38-10.06c9-52.48,14.43-70.69,16.32-70.53.23,0,.58.23.52.46-10.92,49.15-17,73.12-17.87,77-4,6.44-12.82,8.85-16,6.21-5.69-4.72,14.65-44,18.67-54.89,3.79-10.18,7.24-25.75,10.41-35.17a7.56,7.56,0,0,1,7.71-5.11c9.88.63,17.18-4.2,22.24-5.75a4.94,4.94,0,0,1,5.81,2.76c24.42,57.14,51.72,82.43,50.57,100.3-.63,9.25-5.21,14.08-11.14,16-9.55,3.16-20.87-2.13-22.65-12.07-7-39.37-18.34-88.52-16.21-90,2.47-.17,13.83,50.15,15.05,80.64-.29,9.94-1.45,19.48-7.1,27.71l-26.63,39.37s-2.48,10.59-19.55,11.85c-25.92,2-30.58-34.35-8.45-42.75s46.1,41.08,8.45,42.75c-21.21.92-23.62-17-22.07-26a28.24,28.24,0,0,1,10.51-17.53c14.09-11.15,50.59-39.83,50.76-36.61.12,1.89-4.65,5.34-10.18,8.39a19,19,0,0,1-28.45-13.68c-1.66-10,1.1-18.74,1.21-21.44.23-4.54-5.17,1.09-1.21,1.3,3.62.23,2.42-6.55,6-16.67,6.15-17.29,14.43-39.54,8.85-48.74-3.9-6.2-18.45-.05-31.44-16.67-10.11-13.5-6.89-30.06-4.19-34.54s4.48,1.44-1.5,6.32c-4.36,3.62-19.83-8.21-9.66-23.39,9.15-12.7,23.29-10.57,29.32-3.91,4.14,4.6.92,13.22-1.61,10.86-4.37-4,24.89-10.18,8.85-.52-16.89,10.23-14.65,32.76-11.66,39.2.46,2.6,5.69,2.13,5.28-1.61-.28-2.64-1.38-3.39-2.64-3.33-4.08.28-2.7,4.88-2.7,4.88,11.09,29.6,42.76,19.32,51.16.09s-1-30.21-3.23-31.87c-3.1-2.36-7.07-1.2-5.45,5.07,1.76,6.75,8.06,13.51,14.81,11.75"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  );
}
